import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  const user = this.authService.getAuthFromLocalStorage();
  if (user) {
    this.authService.currentUserValue = user;
    return true;
  }

    // not logged in so redirect to login page with the return url
    this.authService.logout();
    return false;
  }
}
